import colors from '@general/colors';
import fonts from '@general/fonts';
import React from 'react';

function getInitial(name) {
    if (Array.isArray(name)) {
        return getInitial(name.filter(Boolean).join(''));
    }

    return name.charAt(0).toUpperCase();
}

export default function HeadShot({ firstName, lastName, imgUrl }) {
    if (imgUrl) {
        return (
            <img alt={`${firstName} ${lastName}`} src={imgUrl} style={{ width: 26, height: 26, borderRadius: '50%' }} />
        );
    }

    return (
        <div
            title={`${firstName} ${lastName}`}
            style={{
                cursor: "default",
                height: 26,
                width: 26,
                backgroundColor: colors.primaryDark,
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <span style={{ color: colors.white, fontSize: 12, fontFamily: fonts.sans }}>
                {[firstName, lastName].map(getInitial).join('')}
            </span>
        </div>
    );
}
